export default {
  'menu.welcome': '欢迎',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.dashboard': '工作台',
  'menu.admin': '管理页',
  'menu.admin.sub-page': '二级管理页',
  'menu.login': '登录',
  'menu.register': '注册',
  'menu.register-result': '注册结果',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.table-list': '查询表格',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.settings': '个人设置',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',
  'menu.task': '任务管理',
  'menu.issue': '问题反馈',
  'menu.notifications': '通知中心',
  'menu.messages': '消息中心',
  'menu.customerFollowUp': '客户跟进',
  'menu.productInitiation': '立项管理',
  'menu.productInitiation.list': '立项列表',
  'menu.productInitiation.detail': '立项详情',
  'menu.requirement': '需求管理',
  'menu.requirement.list': '需求列表',
  'menu.feedback': '员工心声',
  'menu.feedback.list': '员工心声',
  'menu.adminTab': '管理页',
  'menu.myAudit': '我的操作',
  'menu.oa': '办公',
  'menu.oa.announcement': '公告中心',
  'menu.oa.announcementDetail': '公告详情',
  'menu.oa.document': '文档中心',
  'menu.oa.report': '周报月报',
  'menu.oa.reportDetail': '报告详情',
  'menu.oa.approval': '流程审批',
  'menu.oa.approval.todo': '待审批',
  'menu.oa.approval.mine': '我的申请',
  'menu.oa.approval.cc': '抄送我的',
  'menu.oa.approval.all': '全部审批',
  'menu.oa.approval.detail': '审批详情',
  'menu.oa.asset': '行政资产',
  'menu.oa.assetRecords': '资产记录',
  'menu.oa.discussion': '讨论区',
};
